import { getText, appendText } from '../../../assets/js/text-renderer';

import './features-analytics.scss';
import '../../shared/dynamic-tabs/dynamic-tabs.js';

export const loadText = async (mainLandingEl, ctaButtons) => {
  const data = await getText('platform/intelek-smart-analytics/intelek-smart-analytics-features');
  const content = data.stories[0].content;

  setHeroContent(content, ctaButtons, mainLandingEl);
  setFeaturedContent(content, mainLandingEl);
  setActionsContent(content, mainLandingEl);
  setFeaturesContent(content, mainLandingEl);
  setAlertsContent(content, mainLandingEl);
  setMonitoringContent(content, mainLandingEl);
};

function setHeroContent(content, ctaButtons, mainLandingEl) {
  appendText(content.hero_title, 'hero-title', mainLandingEl);
  appendText(ctaButtons.start_trial_btn, 'hero-cta-trial-button', mainLandingEl);
  appendText(ctaButtons.book_demo_btn, 'hero-cta-demo-button', mainLandingEl);
  appendText(content.summary, 'summary', mainLandingEl);
}

function setFeaturedContent(content, mainLandingEl) {
  appendText(content.featured_items[0].title, 'fast-filter-tab', mainLandingEl);
  appendText(content.featured_items[0].description, 'fast-filter-text', mainLandingEl);
  appendText(content.featured_items[1].title, 'organize-graphics-tab', mainLandingEl);
  appendText(content.featured_items[1].description, 'organize-graphics-text', mainLandingEl);
  appendText(content.featured_items[2].title, 'favorite-states-tab', mainLandingEl);
  appendText(content.featured_items[2].description, 'favorite-states-text', mainLandingEl);
}

function setActionsContent(content, mainLandingEl) {
  appendText(content.actions_title, 'actions-title', mainLandingEl);
  appendText(content.actions_items[0].text, 'action-item-0', mainLandingEl);
  appendText(content.actions_items[1].text, 'action-item-1', mainLandingEl);
  appendText(content.actions_items[2].text, 'action-item-2', mainLandingEl);
  appendText(content.actions_items[3].text, 'action-item-3', mainLandingEl);
  appendText(content.actions_items[4].text, 'action-item-4', mainLandingEl);
  appendText(content.actions_items[5].text, 'action-item-5', mainLandingEl);
}

function setFeaturesContent(content, mainLandingEl) {
  appendText(content.features_items[0].title, 'suggested-tab', mainLandingEl);
  appendText(content.features_items[0].description, 'suggested-text', mainLandingEl);
  appendText(content.features_items[1].title, 'filters-tab', mainLandingEl);
  appendText(content.features_items[1].description, 'filters-text', mainLandingEl);
  appendText(content.features_items[2].title, 'transform-tab', mainLandingEl);
  appendText(content.features_items[2].description, 'transform-text', mainLandingEl);
  appendText(content.features_items[3].title, 'customize-tab', mainLandingEl);
  appendText(content.features_items[3].description, 'customize-text', mainLandingEl);
}

function setAlertsContent(content, mainLandingEl) {
  appendText(content.alerts, 'alerts', mainLandingEl);
}

function setMonitoringContent(content, mainLandingEl) {
  appendText(content.monitoring_title, 'monitoring-title', mainLandingEl);
  appendText(content.monitoring_items[0].title, 'organization-tab', mainLandingEl);
  appendText(content.monitoring_items[0].description, 'organization-text', mainLandingEl);
  appendText(content.monitoring_items[0].title, 'clients-tab', mainLandingEl);
  appendText(content.monitoring_items[0].description, 'clients-text', mainLandingEl);
}
